var $76abafa9eee84d55$exports = {};
$76abafa9eee84d55$exports = {
    "actions": `Dzia\u{142}ania`,
    "actionsAvailable": `Dost\u{119}pne dzia\u{142}ania.`,
    "clearSelection": `Wyczy\u{15B}\u{107} zaznaczenie`,
    "selected": (args)=>`Zaznaczono: ${args.count}`,
    "selectedAll": `Wszystkie zaznaczone`
};


export {$76abafa9eee84d55$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
